import { render, staticRenderFns } from "./PersonalMeasurements.vue?vue&type=template&id=3631fac8&scoped=true&"
import script from "./PersonalMeasurements.vue?vue&type=script&lang=js&"
export * from "./PersonalMeasurements.vue?vue&type=script&lang=js&"
import style0 from "./PersonalMeasurements.vue?vue&type=style&index=0&id=3631fac8&scoped=true&lang=css&"
import style1 from "./PersonalMeasurements.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631fac8",
  null
  
)

export default component.exports